(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-archive-padding300"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    let imgTags = document.getElementsByClassName('videoThumb');

    for (let i = 0; i < imgTags.length; i++) {
      let videoId = imgTags[i].getAttribute('data-video-id');
      imgTags[i].addEventListener('click', function () {
        openModal(videoId);
      });
    }

    let modal = document.createElement('div');
    modal.id = 'modal';
    modal.style.display = 'none';
    modal.style.position = 'fixed';
    modal.style.zIndex = '3';
    modal.style.left = '0';
    modal.style.top = '0';
    modal.style.width = '100%';
    modal.style.height = '100%';
    modal.style.overflow = 'auto';
    modal.style.backgroundColor = 'rgba(0,0,0,0.4)';
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });
    let modalContent = document.createElement('div');
    modalContent.className = 'modalContent';
    let videoPlayer = document.createElement('iframe');
    videoPlayer.id = 'videoPlayer';
    videoPlayer.width = '560';
    videoPlayer.height = '315';
    videoPlayer.frameBorder = '0';
    videoPlayer.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    videoPlayer.allowFullscreen = true;
    let closeBtn = document.createElement('button');
    closeBtn.className = 'closeBtn';
    closeBtn.addEventListener('click', closeModal);

    modalContent.appendChild(videoPlayer);
    modalContent.appendChild(closeBtn);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
  });
  function openModal(videoId) {
    let modal = document.getElementById('modal');
    let videoPlayer = document.getElementById('videoPlayer');

    videoPlayer.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    modal.style.display = 'block';
  }
  function closeModal() {
    let modalContent = document.querySelector('.modalContent');

    setTimeout(function () {
      let modal = document.getElementById('modal');
      let videoPlayer = document.getElementById('videoPlayer');

      videoPlayer.src = '';
      modal.style.display = 'none';
    }, 700);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-archive"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    let imgTags = document.getElementsByClassName('videoThumb');
    for (let i = 0; i < imgTags.length; i++) {
      let videoId = imgTags[i].getAttribute('data-video-id');
      imgTags[i].addEventListener('click', function () {
        openModal(videoId);
      });
    }

    let modal = document.createElement('div');
    modal.id = 'modal';
    modal.style.display = 'none';
    modal.style.position = 'fixed';
    modal.style.zIndex = '3';
    modal.style.left = '0';
    modal.style.top = '0';
    modal.style.width = '100%';
    modal.style.height = '100%';
    modal.style.overflow = 'auto';
    modal.style.backgroundColor = 'rgba(0,0,0,0.4)';
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });
    let modalContent = document.createElement('div');
    modalContent.className = 'modalContent';
    let videoPlayer = document.createElement('iframe');
    videoPlayer.id = 'videoPlayer';
    videoPlayer.width = '560';
    videoPlayer.height = '315';
    videoPlayer.frameBorder = '0';
    videoPlayer.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    videoPlayer.allowFullscreen = true;
    let closeBtn = document.createElement('button');
    closeBtn.className = 'closeBtn';
    closeBtn.addEventListener('click', closeModal);

    modalContent.appendChild(videoPlayer);
    modalContent.appendChild(closeBtn);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
  });
  function openModal(videoId) {
    let modal = document.getElementById('modal');
    let videoPlayer = document.getElementById('videoPlayer');

    videoPlayer.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    modal.style.display = 'flex';
  }
  function closeModal() {
    let modalContent = document.querySelector('.modalContent');
    modalContent.style.animation = 'fadeOut 0.7s';

    setTimeout(function () {
      let modal = document.getElementById('modal');
      let videoPlayer = document.getElementById('videoPlayer');

      videoPlayer.src = '';
      modal.style.display = 'none';
      modalContent.style.animation = 'fadeIn 0.7s';
    }, 300);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-concept-factory"] && !Shopify.designMode) return;
  try {
    
  const mvSwiperFactry = new Swiper('.page-concept-factry__slider', {
    // loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.page-concept-factry__slider .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.page-concept-factry__slider .swiper-button-next',
      prevEl: '.page-concept-factry__slider .swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-concept-sustainable"] && !Shopify.designMode) return;
  try {
    
  const mvSwiperSustainable = new Swiper('.page-concept-sustainable__grid-item-slider', {
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.page-concept-sustainable__grid-item-slider .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.page-concept-sustainable__grid-item-slider .swiper-button-next',
      prevEl: '.page-concept-sustainable__grid-item-slider .swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-looks-feature"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.page-looks-feature__swiper', {
    loop: true,
    spaceBetween: 10,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1.2,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-looks-list-add-slider"] && !Shopify.designMode) return;
  try {
    
  const mvSwiper = new Swiper('.mv-swiper-list-slider', {
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,

    pagination: {
      el: '.mv-swiper-list-slider .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.mv-swiper-list-slider .swiper-button-next',
      prevEl: '.mv-swiper-list-slider .swiper-button-prev',
    },
  });

  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.getElementById('viewMoreLooksBtn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var items = document.querySelectorAll('.looks__list .is-hidden');
      items.forEach(function (item) {
        item.classList.remove('is-hidden');
      });
      btn.style.display = 'none';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-looks-slider-title"] && !Shopify.designMode) return;
  try {
    
  const mvSwiper = new Swiper('.mv-swiper', {
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-looks-slider"] && !Shopify.designMode) return;
  try {
    
  const mvSwiper = new Swiper('.mv-swiper', {
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,

    pagination: {
      el: '.mv-swiper .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.mv-swiper .swiper-button-next',
      prevEl: '.mv-swiper .swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    var footer = document.querySelector('.footer');
    if (!footer) {
      // .footer要素が見つからなかった時は終了
      return;
    }

    var footerHeight = footer.offsetHeight;

    window.onscroll = function () {
      var point = window.pageYOffset;
      var docHeight = document.documentElement.scrollHeight;
      var dispHeight = window.innerHeight;

      var banner = document.querySelector('.common-banner');
      if (!banner) return;

      if (point > docHeight - dispHeight - footerHeight) {
        banner.classList.add('is-hidden');
      } else {
        banner.classList.remove('is-hidden');
      }
    };
  });

  const button = document.querySelector('.js-backToTop');

  button.addEventListener('click', () => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  });

  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      button.classList.add('is-active');
    } else {
      button.classList.remove('is-active');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
